export default {
    data: {
        accessibility: {
            classMapping: undefined,
            isToolEnabled: undefined,
        },
        app: {
            appVersion: undefined,
            backendType: undefined,
            baseName: undefined,
            defaultVeevImage: undefined,
            deviceListOrder: undefined,
            env: undefined,
            isDataCollectionEnabled: undefined,
            isReconnectDeviceGuideEnabled: undefined,
            publicUrl: undefined,
            isCaptchaEnabled: undefined,
            isSuccessfullyUpdatedPageIconEnabled: undefined,
            isBLEEnabled: undefined,
        },
        appLinks: {
            linkAndroidStoreChrome: undefined,
            linkDesktopChrome: undefined,
            linkIosStoreBluenet: undefined,
            linkAndroidStoreEdge: undefined,
            linkDesktopEdge: undefined,
        },
        aws: {
            awsRegion: undefined,
        },
        deviceConnectionType: {
            bleDisabled: [],
        },
        deviceSupport: {
            enableCortezSupport: undefined,
            enableCosmosSupport: undefined,
            enableDeltaSupport: undefined,
            enableOrdinarySupport: undefined,
            enableP4Support: undefined,
            enableSoyuzSupport: undefined,
            enableVespucciSupport: undefined,
            enableOriginalOneSupport: undefined,
            enableArianeSupport: undefined,
            enableOriginalDuoSupport: undefined,
            enableVoyagerSupport: undefined,
            enableHermesPrimeSupport: undefined,
            enableHermesMidSupport: undefined,
            enableJunoSupport: undefined,
        },
        externalLinks: {
            dcsSupportUrl: undefined,
            footerCompanyInfoUrl: undefined,
            footerPrivacyNoticeUrl: undefined,
            footerUserLicenseUrl: undefined,
            iqosHomeUrl: undefined,
            iqosStoreUrl: undefined,
        },
        fwu: {
            bleFwuDisabled: [],
            areNewPopupsEnabled: false,
            reconnectAnimationVideo: undefined,
        },
        gam: {
            gamApiUrl: undefined,
            gamWssUrl: undefined,
        },
        icc: {
            iccApiBodyScope: undefined,
            iccApiHeader_a: undefined,
            iccApiHeader_m: undefined,
            iccApiHeaderAuthorization: undefined,
            iccApiHeaderUsername: undefined,
            iccApiUrl: undefined,
        },
        iccConsumerServices: {
            isICCConsumerServiceEnabled: undefined,
            isTNCEnabled: undefined,
        },
        localization: {
            localizationMapping: undefined,
            languages: undefined,
        },
        login: {
            ageGateMinAge: undefined,
            ageGateLockTime: undefined,
        },
        logs: {
            awsLogLevel: undefined,
            isAppVersionVisible: undefined,
            isAwsLoggingEnabled: undefined,
            isDebug: undefined,
            isLogsVisible: undefined,
            logLevel: undefined,
            mqttDebugLevel: undefined,
        },
        scp: {
            scpApiUrl: undefined,
            scpCloudTopicMarket: undefined,
            scpCloudTopicMarketPrefix: undefined,
            scpCloudVersion: undefined,
        },
        storage: {
            assetsPath: undefined,
            path: undefined,
            externalConfig: {
                folderName: undefined,
                linksFileName: undefined,
                videoGuidesConfigFileName: undefined,
            },
            reconnectGuideAssetsPath: undefined,
            legalDisclaimerPdfName: undefined,
            specificLocalizationFileName: undefined,
            connectionPageImagePath: undefined,
            commonLocalizationFileName: undefined,
        },
    },
};
